import {
  ActionType,
  MiniStressTypeCSVDownloadResponse,
  IMiniStressTypeDownloadCsvData,
} from "models/stressCheck/miniStressTypeDownloadCsv";

export const miniStressCsvDownloadAction = (
  payload: IMiniStressTypeDownloadCsvData
) => {
  return {
    type: ActionType.MINI_STRESS_TYPE_DOWNLOAD_CSV,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.MINI_STRESS_TYPE_DOWNLOAD_CSV_ERROR,
    payload,
  };
};

export const handleSuccesAction = (
  payload: MiniStressTypeCSVDownloadResponse
) => {
  return {
    type: ActionType.MINI_STRESS_TYPE_DOWNLOAD_CSV_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.MINI_STRESS_TYPE_DOWNLOAD_CSV_RESET_DATA,
  };
};
